import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';

// analytics is initialized in App component due to multi brand
export const bootstrap = new BootstrapBrowserBuilder('renter-hub-web', Number(__BUILD_NUMBER__))
  .withLoggerOptions({
    logPath: `/renter-hub/log`,
    level: __LOG_LEVEL__,
  })
  .build();
